
import _ from 'lodash'
import React from 'react'
import {  Button, Modal  } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// eslint-disable-line`
import '../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { PropTypes } from 'prop-types'
import {  change  } from 'redux-form'
import { warning } from './sitecolors'


const ModalTable = ({ title,  dispatch, records }) => {  

	function handleRowSelect(row){
		const { certnumber, name } = row
		const center = _.find(records.Results,{ certnumber:certnumber })

		dispatch(change('eventinfo','centername',name))
		dispatch(change('eventinfo','centercertnumber',certnumber))
		dispatch(change('eventinfo','eventaddress',center.address))
		dispatch(change('eventinfo','eventstate',center.state))
		dispatch(change('eventinfo','eventzipcode',center.zip))
		dispatch(change('eventinfo','eventcity',center.city))
		dispatch(change('eventinfo','eventcountry',center.country))
		// this closes the window
		dispatch(change('eventinfo','centers',null))
	}
	function handleModalClose() {
		dispatch(change('eventinfo','centers',null))
	}
	const selectRowProp = {
		mode: 'radio',  
		onSelect: handleRowSelect
	}
	return(
		<Modal show style={{ position:'absolute',top:'10%', transform: 'translate(-10%) !important' }} onHide={this.handleModalClose} >
			<Modal.Header>
				<Modal.Title style={{ color:warning }}>
						<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;{title}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<BootstrapTable data={records.Results} striped hover search multiColumnSearch selectRow={selectRowProp} pagination>
					<TableHeaderColumn isKey dataField='certnumber'>Center Cert Number</TableHeaderColumn>
					<TableHeaderColumn dataField='name'>Center Name</TableHeaderColumn>
					<TableHeaderColumn dataField='citystatezip'>Center City, State, Zip</TableHeaderColumn>
				</BootstrapTable>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={handleModalClose}>Close</Button>
			</Modal.Footer>
		</Modal>
	)
}

ModalTable.propTypes = {
	title: PropTypes.string.isRequired,
	records: PropTypes.object.isRequired,
	dispatch:PropTypes.func
}

export default ModalTable


// WEBPACK FOOTER //
// ./src/utils/modaltable.js